import React, { useEffect } from "react";
import Sidebar from "../../components/sidebar/Sidebar";
import MainSection from "../../components/mainLayout/Main";
import SectionHeader from "../../components/sectionHeader/SectionHeader";
import MemberTaskHome from "./components/MemberTaskHome";
import { useSearchParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getOneEmployee } from "../../redux/actions/authActions";

const MemberTask = () => {
  const [searchParams] = useSearchParams();
  const memberId = searchParams.get("memberId");
  const dispatch = useDispatch();
  const employee = useSelector((state) => state.auth.employee);

  useEffect(() => {
    if (memberId) {
      dispatch(getOneEmployee(memberId));
    }
  }, [dispatch, memberId]);

  return (
    <>
      <Sidebar />

      <MainSection>
        <SectionHeader title={employee?.name ? `${employee.name}'s Tasks` : "Tasks"} />
        <MemberTaskHome />
      </MainSection>
    </>
  );
};

export default MemberTask;
